import React from "react";
import "./Style/GotoAll.scss"; // Import styles
import { GO_TO_ALL_LINKS } from "./Constant"; // List of link names
import { useHistory } from "react-router-dom"; // For navigation
import constants from "../../Utils/constants"; // Route constants
import { formatRoute } from "react-router-named-routes"; // To safely format routes

const GotoAll = () => {
  const history = useHistory(); // React Router hook to programmatically navigate

  // Map of link names to route paths
  const routeMap = {
    Board: constants.APPLICATION_ROUTE.MY_BOARDS.LIST.ROUTE,
    Visualization: constants.APPLICATION_ROUTE.DATA_VISUALIZATION.VIEW.ROUTE,
    "Preferences Center": constants.APPLICATION_ROUTE.MANAGE_PREFERENCES.ROUTE,
    Project: constants.APPLICATION_ROUTE.PROJECT.LIST.ROUTE,
  };

  // Handle button click to navigate to appropriate route
  const handleRedirect = (linkName) => {
    const path = routeMap[linkName]; // Get route from map
    if (path) {
      history.push(formatRoute(path, {})); // Navigate using formatted route
    }
  };

  return (
    <div className="go-to-all">
      <p>GO TO ALL:</p>
      {GO_TO_ALL_LINKS.map((link, idx) => (
        <button
          key={idx}
          className="go-link ml-2 hover-go-all-link"
          onClick={() => handleRedirect(link)} // Navigate on click
        >
          {link}
        </button>
      ))}
    </div>
  );
};

export default GotoAll;
